import classNames from "classnames";
import styles from "./FormsApplicationListItem.module.scss";
import {
  formatFormApplicationTimestamp,
  getFormApplicationTypeMeta,
} from "../../_constants/formsApplications.const";
import { FormApplication } from "../../_types/formsApplications.types";

type FormsApplicationListItemProps = {
  application: FormApplication;
  onClick: () => void;
};

export const FormsApplicationListItem = ({
  application,
  onClick,
}: FormsApplicationListItemProps) => {
  const typeMeta = getFormApplicationTypeMeta(application.type);

  return (
    <button
      type="button"
      className={classNames(
        styles["comp"],
        application.read ? styles["comp--read"] : styles["comp--unread"],
      )}
      onClick={onClick}
    >
      <div className={styles["comp__person"]}>
        <div className={styles["comp__sender"]}>
          <div className={styles["comp__name"]}>{application.fullName}</div>
          <div className={styles["comp__email"]}>{application.email}</div>
        </div>
      </div>

      <div className={styles["comp__category"]}>
        <span
          className={classNames(
            styles["comp__badge"],
            styles[`comp__badge--${typeMeta.variant}`],
          )}
        >
          {typeMeta.label}
        </span>
      </div>

      <div className={styles["comp__content"]}>{application.content}</div>

      <time className={styles["comp__timestamp"]}>
        {formatFormApplicationTimestamp(application.createdAt)}
      </time>
    </button>
  );
};
